<template>
    <div class="step-four container">
        <ui-card-tab-main active="prices">
            <ui-card-tab-button content="prices">Definir Preços</ui-card-tab-button>
            <!--****************************************************
            *** removido por Tiago Dariel a pedido de Helio Cesar **
            *****************************************************-->
            <!--<ui-card-tab-button content="categories">Categorizar Unidades</ui-card-tab-button>-->
            <ui-card-tab-button content="sales">Gerenciar Tabelas de Vendas</ui-card-tab-button>

            <ui-card-tab-content id="prices" class="page">
                <ui-unity-values
                    v-if="product.availability"
                    :data="product.availability"/>
            </ui-card-tab-content>

            <!--<ui-card-tab-content class="page" id="categories">
                <ui-unity-categories v-if="product.availability"
                    :data="product.availability"/>
            </ui-card-tab-content>-->

            <ui-card-tab-content id="sales" class="page">
                <ui-sales-table
                    v-if="product.availability"
                    :data="product.availability"
                    :product-id="product.id"/>
            </ui-card-tab-content>
        </ui-card-tab-main>

        <!-- Modal Simulator Rules / Regras do Simulador -->
        <ui-simulator-rules />

        <!-- Modal Commission Rules / Regras do Comissão -->
        <ui-commission-rules />
        
        <!-- Modal Adjustable Installments / Parcelas Reajustáveis -->
        <ui-adjustable-installments />

        <ui-dates-proposal/>

        <!-- Sidebar for Select Caterories in units -->
        <ui-sidebar-unity-categories />
        

        <!-- Modal de confirmação de exclusão da tabela de vendas -->
        <ui-modal-message
            name="delete-sales-table"
            title="Tem certeza que deseja excluir esta tabela?"
            text="Não será possível desfazer essa ação."
            btn-type="danger"
            btn-text="Confirmar"
        />

        <!-- Modal de confirmação de exclusão de um fluxo da tabela de vendas -->
        <ui-modal-message
            name="delete-sales-table-flow"
            title="Tem certeza que deseja excluir esse fluxo?"
            text="Não será possível desfazer essa ação."
            btn-type="danger"
            btn-text="Confirmar"
        />

        <!-- Modal de confirmação ao criar nova tabela -->
        <ui-modal-sales-table-new />

        <!-- Modal de Clonar uma tabela existente -->
        <ui-modal-sales-table-clone />
    </div>
</template>

<script>
import { uiCardTabButton, uiCardTabContent, uiCardTabMain } from "@/components/ui/cards"
import { uiModalMessage } from '@/components/ui/modal'
import { product } from '@/services/axios'
import uiUnityValues from "./unity-values"
// import uiUnityCategories from "./unity-categories"
import { alertMixin } from '@/mixins'
import { mapActions } from 'vuex'
import uiSalesTable from "./sales-table"

import uiModalSalesTableClone from './sales-table/components/modal-sales-table-clone'
import uiModalSalesTableNew from './sales-table/components/modal-sales-table-new'
import uiSimulatorRules from './sales-table/components/simulator-rules'
import uiAdjustableInstallments from './sales-table/components/adjustable-installments'
import uiCommissionRules from './sales-table/components/commission-rules'
import uiDatesProposal from './sales-table/components/dates-proposal'
import uiSidebarUnityCategories from './unity-categories/components/sidebar/'

    export default {
        name:"ui-product-steep",
        components: {
            uiCardTabMain,
            uiCardTabButton,
            uiCardTabContent,
            uiAdjustableInstallments,
            uiUnityValues,
            // uiUnityCategories,
            uiSalesTable,
            uiSimulatorRules,
            uiCommissionRules,
            uiDatesProposal,
            uiSidebarUnityCategories,
            uiModalMessage,
            uiModalSalesTableNew,
            uiModalSalesTableClone,
        },
        mixins: [
            alertMixin
        ],
        props: {
            id: {
                type: [String, Number],
                required: true,
                default: ""
            }
        },
        data() {
            return {
                product: {}
            }
        },
        created() {
            product.getAvailabilityStep4(this.id)
                .then(response => {
                    this.product = { ...response.data }
                    this.$store.dispatch('product/setProduct', response.data)
                })
                .catch(error => {
                    this.$mx_alertError(error?.data?.msg)
					if (!error?.data?.msg) {
						this.updateDetails(error?.data?.msg)
						this.$router.push({ name: 'products.dataUnits' })
					}

					if (!error?.data?.details?.hasPermission) {
						this.updateDetails(error?.data?.details)
						this.$router.push({ name: 'products.dataUnits' })
					}
                })
        },

        methods: {
            ...mapActions('detailsHasPermissions', ['updateDetails']),
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl';
</style>